export const REQUEST_FULL_LINE = 'REQUEST_FULL_LINE';
export const SUCCESS_REQUEST_FULL_LINE = 'SUCCESS_REQUEST_FULL_LINE';
export const FAILURE_REQUEST_FULL_LINE = 'FAILURE_REQUEST_FULL_LINE';

export const REQUEST_LINE_HEADERS = 'REQUEST_LINE_HEADERS';
export const SUCCESS_REQUEST_LINE_HEADERS = 'SUCCESS_REQUEST_LINE_HEADERS';
export const FAILURE_REQUEST_LINE_HEADERS = 'FAILURE_REQUEST_LINE_HEADERS';

export const REQUEST_SPORT_LINE_HEADERS = 'REQUEST_SPORT_LINE_HEADERS';
export const SUCCESS_REQUEST_SPORT_LINE_HEADERS = 'SUCCESS_REQUEST_SPORT_LINE_HEADERS';
export const FAILURE_REQUEST_SPORT_LINE_HEADERS = 'FAILURE_REQUEST_SPORT_LINE_HEADERS';

export const REQUEST_LEAGUE_LINE_HEADERS = 'REQUEST_LEAGUE_LINE_HEADERS';
export const SUCCESS_REQUEST_LEAGUE_LINE_HEADERS = 'SUCCESS_REQUEST_LEAGUE_LINE_HEADERS';
export const FAILURE_REQUEST_LEAGUE_LINE_HEADERS = 'FAILURE_REQUEST_LEAGUE_LINE_HEADERS';

export const CLEAR_LINE = 'CLEAR_LINE';

export const SHOW_LINE_NUMBERS = 'SHOW_LINE_NUMBERS';
export const HIDE_LINE_NUMBERS = 'HIDE_LINE_NUMBERS';



// WEBPACK FOOTER //
// ./js/actions/Line.js